import {IMultiOccurrenceOptions} from '../../../../../core/services/multi-occurrence.service';
import {IFormulaireItemClass} from '../../../../../core/services/formulaire/formulaire-item.service';
import {IFormulaire, IFormulaireClass} from '../../../../../core/services/formulaire/formulaire.service';
import {IComponentController} from "angular";
import {IMonoOccurrenceOptions} from '../../../../../core/services/mono-occurrence.service';
import { IFormulaireGroupeClass } from '../../../../../core/services/formulaire/formulaire-groupe.service';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';

interface IPageGs2004 extends IComponentController {
    formulaireSur: IFormulaire;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    srpMultiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Gs2004Controller(Formulaire: IFormulaireClass,
                                         FormulaireItem: IFormulaireItemClass,
                                         FormulaireGroupe: IFormulaireGroupeClass,
                                         FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass
                                        ) {
    const vm: IPageGs2004 = this;

    // Client d'application
    vm.formulaireSur = new Formulaire('LBL_BLC_SUR', [
        new FormulaireItem('trldsc',  {largeur: 25}),
        new FormulaireItem('surdsclan',  {largeur: 25}),
        new FormulaireItemSautDeLigne(),

        new FormulaireGroupe('LBL_GRP_IMP',
            new Formulaire([
            ], {largeurDefaut: 100  }), {largeur: 33}
        ),    
        new FormulaireGroupe('LBL_GRP_EXE',
            new Formulaire([
            ], {largeurDefaut: 100 }), {largeur: 33}
        ),
        new FormulaireGroupe('LBL_GRP_FIN',
            new Formulaire([
            ], {largeurDefaut: 100  }), {largeur: 33}
        ),

        new FormulaireItem('impdsc', {largeur: 33}),
        new FormulaireItem('surdatdif_car', {largeur: 33}),
        new FormulaireItem('surtypficimp', {largeur: 33}),
        new FormulaireItemSautDeLigne(),

        new FormulaireItem('surnbrcop', {largeur: 33}),
        new FormulaireItem('surdatdebexe_car', {largeur: 33}),
        new FormulaireItem('surfintrtdsc', {largeur: 33}),
        new FormulaireItemSautDeLigne(),

        new FormulaireItem('', {largeur: 33}),
        new FormulaireItem('surdatfinexe_car', {largeur: 33}),
        new FormulaireItem('', {largeur: 33}),
        new FormulaireItemSautDeLigne(),

        new FormulaireItem('', {largeur: 33}),
        new FormulaireItem('surduree', {largeur: 33}),
        new FormulaireItem('', {largeur: 33}),
        new FormulaireItemSautDeLigne(),

        new FormulaireItem('', {largeur: 33}),
        new FormulaireItem('fiadsc', {largeur: 33}),
        new FormulaireItem('', {largeur: 33}),
        new FormulaireItemSautDeLigne()
    ], { largeurDefaut: 100 });

    // Parametres
    vm.srpMultiOccurrenceOptions = {
        bloc: 'srp',
        colonnesVisibles: [
            {nom: 'ptllab', largeur: 200},
            {nom: 'survalsai', largeur: 140}
        ],
        formulaire: new Formulaire([
            new FormulaireItem('ptllab', {largeur: 66}),
            new FormulaireItem('survalsai')
        ], { largeurDefaut: 33 })
    };
}
